import { useState } from 'react';
import { Card, Badge } from 'antd';
import FeatherIcon from 'feather-icons-react';

/**
 * Reusable Section Card Component - Improved Variant
 * Better expandable icon placement and visibility
 */
const SectionCard = ({
    title,
    icon,
    badge,
    badgeColor = '#10b981',
    children,
    defaultOpen = true,
    isCompleted = false,
    isRequired = false,
    className = '',
    headerExtra,
}) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);
    const [isHovered, setIsHovered] = useState(false);

    return (
        <Card
            className={`section-card ${className}`}
            style={{
                borderRadius: '12px',
                boxShadow: isHovered ? '0 4px 12px rgba(0,0,0,0.12)' : '0 2px 8px rgba(0,0,0,0.08)',
                marginBottom: '10px',
                border: `1px solid ${isHovered ? '#d1d5db' : '#e5e7eb'}`,
                overflow: 'hidden',
                transition: 'all 0.2s ease',
            }}
            bodyStyle={{ padding: 0 }}
        >
            {/* Header */}
            <div
                style={{
                    background: isOpen ? '#f9fafb' : '#ffffff',
                    borderRadius: '12px 12px 0 0',
                    padding: '8px 12px',
                    borderBottom: isOpen ? '2px solid #e5e7eb' : 'none',
                    cursor: 'pointer',
                    transition: 'background 0.2s ease',
                }}
                onClick={() => setIsOpen(!isOpen)}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {/* Section Icon */}
                    <div
                        style={{
                            width: '28px',
                            height: '28px',
                            borderRadius: '6px',
                            background: '#eef2ff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                        }}
                    >
                        <FeatherIcon icon={icon} size="16" style={{ color: '#4f46e5' }} />
                    </div>

                    {/* Title and Badges */}
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                            <h4
                                style={{
                                    color: '#111827',
                                    fontWeight: '700',
                                    fontSize: '16px',
                                    margin: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                }}
                            >
                                {title}
                                {isRequired && (
                                    <span style={{ color: '#ef4444', fontSize: '16px' }}>*</span>
                                )}
                            </h4>

                            {/* Badges */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                {badge !== undefined && badge !== null && (
                                    <Badge
                                        count={badge}
                                        style={{
                                            backgroundColor: badgeColor,
                                            fontSize: '11px',
                                            fontWeight: '600',
                                            padding: '0 8px',
                                            height: '20px',
                                            lineHeight: '20px',
                                            boxShadow: 'none',
                                        }}
                                    />
                                )}

                                {isCompleted && (
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '4px',
                                            background: '#d1fae5',
                                            padding: '4px 10px',
                                            borderRadius: '12px',
                                        }}
                                    >
                                        <FeatherIcon
                                            icon="check-circle"
                                            size="14"
                                            style={{ color: '#10b981' }}
                                        />
                                        <span
                                            style={{
                                                fontSize: '11px',
                                                fontWeight: '600',
                                                color: '#059669',
                                            }}
                                        >
                                            Completed
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Optional subtitle or description */}
                        {/* {!isOpen && isRequired && !isCompleted && (
                            <p
                                style={{
                                    fontSize: '12px',
                                    color: '#9ca3af',
                                    margin: '4px 0 0 0',
                                }}
                            >
                                Required section - Click to expand
                            </p>
                        )} */}
                    </div>

                    {/* Header Extra Content */}
                    {headerExtra && (
                        <div style={{ marginLeft: 'auto', flexShrink: 0 }}>
                            {headerExtra}
                        </div>
                    )}

                    {/* Expand/Collapse Icon - RIGHT SIDE */}
                    <div
                        style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '8px',
                            background: isOpen ? '#4f46e5' : '#f3f4f6',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.2s ease',
                            flexShrink: 0,
                            marginLeft: '8px',
                        }}
                    >
                        <FeatherIcon
                            icon={isOpen ? 'chevron-up' : 'chevron-down'}
                            size="18"
                            style={{
                                color: isOpen ? '#ffffff' : '#6b7280',
                                transition: 'transform 0.2s ease',
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* Content */}
            {isOpen && (
                <div
                    style={{
                        padding: '16px',
                        background: '#ffffff',
                        animation: 'slideDown 0.2s ease',
                    }}
                >
                    {children}
                </div>
            )}
        </Card>
    );
};

export default SectionCard;
